module.exports = __webpack_public_path__ + "img/[比耶].1e5eb6f0.svg";